import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal';

// eslint-disable-next-line react/display-name
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var IconComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsxs("g", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "currentColor",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M27 10a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm3-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M23 10.148C23 5.982 26.207 3 30 3c3.792 0 7 2.982 7 7.148 0 1.265-.49 2.62-1.248 4.007a23.647 23.647 0 0 1-1.75 2.696 37.468 37.468 0 0 1-2.406 2.92l-.004.004-.27.293L30 21.443l-1.274-1.323-.323-.35-.317-.353a37.468 37.468 0 0 1-2.088-2.567 23.647 23.647 0 0 1-1.751-2.695C23.491 12.768 23 11.413 23 10.148ZM30 5c-2.702 0-5 2.1-5 5.148 0 .777.312 1.782 1.003 3.048.424.776.965 1.602 1.603 2.465a35.493 35.493 0 0 0 1.974 2.426l.302.336.118.128.12-.13a35.493 35.493 0 0 0 2.274-2.76c.639-.863 1.18-1.69 1.603-2.465C34.688 11.93 35 10.925 35 10.148 35 7.1 32.702 5 30 5Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M33.587 20.544c-.18.205-.352.397-.513.573l-.013.015-.061.066v9.184l-8 4V18.84a36.39 36.39 0 0 1-.61-.8A28.071 28.071 0 0 1 23 15.99v9.546a6.211 6.211 0 0 0-7-1.153V10.7l5.934 3.296c-.397-.88-.71-1.808-.852-2.76L15.045 7.88 3 13.356v23.072l11.913-4.332 9.062 5.034L35 31.618V18.84c-.464.592-.94 1.163-1.413 1.704ZM5 18.81v-4.166l9-4.091v14.014a2.464 2.464 0 0 1-1.498-1.402l-.13-.318A6.69 6.69 0 0 0 5 18.81Zm0 2.047v12.715l9-3.272v-3.674a4.466 4.466 0 0 1-3.347-2.7l-.131-.318A4.689 4.689 0 0 0 5 20.858Zm11 9.555 7 3.889v-5.065l-.565-1.13a4.209 4.209 0 0 0-5.646-1.882c-.258.129-.522.23-.789.306v3.882Z"
      })]
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export var PictogramB2BMap40 = createIcon(IconComponent);